/**
 * Wrap jsx conditionally
 *
 * <CondWrap condition={true} wrapper={(children) => <div>{children}</div>} />}>
 *  <p>content goes here</p>
 * </CondWrap>
 */
export const CondWrap = ({ children, condition, wrapper }: any) => (condition ? wrapper(children) : children);
